import { render, staticRenderFns } from "./FactorysTable.vue?vue&type=template&id=2d5eff4f"
import script from "./FactorysTable.vue?vue&type=script&lang=js"
export * from "./FactorysTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports